export const SOCKET_SESSION_EVENTS = {
    AUTH_EXPIRED: 'auth:expired',
    REPLACED: 'session:replaced',
} as const;

export const SOCKET_RETRY_BASE_MS = 1000;

export const SOCKET_RETRY_MAX_MS = 30_000;
